import { Search } from 'lucide-react';
import type { OpportunityStage, ForecastLabel } from '../../types/mavis';
import { OPPORTUNITY_STAGE_LABELS, FORECAST_LABEL_LABELS } from '../../types/mavis';

const STAGES: OpportunityStage[] = [
  'discover', 'qualify', 'validate', 'propose', 'negotiate', 'close_won', 'close_lost',
];

const FORECAST_LABELS: ForecastLabel[] = [
  'low', 'medium', 'high', 'commit_risk', 'commit_ready',
];

interface Props {
  search: string;
  stage: string;
  forecastLabel: string;
  quarter: string;
  quarterOptions: string[];
  onSearchChange: (v: string) => void;
  onStageChange: (v: string) => void;
  onForecastLabelChange: (v: string) => void;
  onQuarterChange: (v: string) => void;
}

export default function MavisForecastFilters({
  search, stage, forecastLabel, quarter, quarterOptions,
  onSearchChange, onStageChange, onForecastLabelChange, onQuarterChange,
}: Props) {
  return (
    <div className="flex flex-wrap gap-3 items-center">
      <div className="relative flex-1 min-w-[200px] max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-app-muted pointer-events-none" />
        <input
          type="text"
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          placeholder="Search opportunities or accounts…"
          className="input-field !pl-9 !py-2 text-sm w-full"
        />
      </div>

      <select
        value={stage}
        onChange={e => onStageChange(e.target.value)}
        className="input-field !py-2 text-sm w-auto"
      >
        <option value="">All Stages</option>
        {STAGES.map(s => (
          <option key={s} value={s}>{OPPORTUNITY_STAGE_LABELS[s]}</option>
        ))}
      </select>

      <select
        value={forecastLabel}
        onChange={e => onForecastLabelChange(e.target.value)}
        className="input-field !py-2 text-sm w-auto"
      >
        <option value="">All Forecasts</option>
        {FORECAST_LABELS.map(l => (
          <option key={l} value={l}>{FORECAST_LABEL_LABELS[l]}</option>
        ))}
      </select>

      <select
        value={quarter}
        onChange={e => onQuarterChange(e.target.value)}
        className="input-field !py-2 text-sm w-auto"
        disabled={quarterOptions.length === 0}
      >
        <option value="">All Quarters</option>
        {quarterOptions.map(q => (
          <option key={q} value={q}>{q}</option>
        ))}
      </select>
    </div>
  );
}
